<template>
  <v-row>
    <v-col cols="8">
      <v-select
        v-model="chosenCharacter"
        :items="characterNames"
        @change="setCharacter()"
        dark />
    </v-col>
    <v-col cols="4">
      <v-btn v-if="chosenCharacter !== ''" @click="resetCharacter();">New Character</v-btn>
    </v-col>
    <v-col cols="12">
      <template v-if="chosenCharacter === ''">
        <newChar :character="character" :existing="characterNames" @create="createCharacter" />
      </template>
      <template v-else>
        <v-card color="primary" dark class="pa-2">
          <v-card-title>
            Character View
            <v-spacer />
            <v-btn color="red" @click="deleteCharacter()">Delete</v-btn>
            <v-spacer />
            <v-btn color="accent" @click="updCharacter()">Save</v-btn>
          </v-card-title>
          <v-card-text class="secondary">
            <charView :character="character" :chosenName="chosenCharacter" />
          </v-card-text>
        </v-card>
      </template>
    </v-col>
  </v-row>
</template>

<script>
import { mapState, mapActions } from 'vuex';
import _ from 'lodash';

export default {
  components: {
    newChar: () => import('./newCharacter'),
    charView: () => import('./characterView')
  },
  data() {
    return {
      chosenCharacter: '',
      character: {
        name: '',
        race: '',
        level: 1,
        xp: 0,
        hpRolls: [],
        statPoints: 6,
        traitPoints: 2,
        physique: 0,
        finesse: 0,
        mind: 0,
        spirit: 0,
        primaryStats: [],
        tertiaryStats: [],
        dumpStats: [],
        traits: [],
        skills: {
          custom: [],
          values: {},
          skillPoints: {
            physique: 0,
            finesse: 0,
            mind: 0,
            spirit: 0,
            general: 0,
            specialty: 0
          }
        },
        inventory: [],
        equippedArmor: {
          name: 'Unarmored',
          type: 'Unarmored',
          ac: '0',
          price: '0',
          weight: '0'
        },
        equippedMain: {
          name: 'Unarmed',
          type: 'Unarmed',
          size: 'Small',
          damage: '1d4',
          stamina: '4',
          price: '0',
          weight: '0'
        },
        equippedOff: {
          name: 'Unarmed',
          type: 'Unarmed',
          size: 'Small',
          damage: '1d4',
          stamina: '4',
          price: '0',
          weight: '0'
        },
        offHandDisabled: false,
        resetTraits: [],
        resetSkills: {
          custom: [],
          values: {},
          skillPoints: {
            physique: 0,
            finesse: 0,
            mind: 0,
            spirit: 0,
            general: 0,
            specialty: 0
          }
        }
      }
    };
  },
  created() {
    this.setupCharacters(this.id);
  },
  methods: {
    ...mapActions('actsCharacters', [
      'setupCharacters',
      'addCharacter',
      'saveCharacter',
      'removeCharacter'
    ]),
    setCharacter() {
      this.character = _.cloneDeep(this.characters.find(character => character.name === this.chosenCharacter));
    },
    createCharacter(newCharacter) {
      const payload = {
        id: this.id,
        character: newCharacter
      };
      this.addCharacter(payload);
      this.chosenCharacter = this.character.name;
    },
    updCharacter() {
      const payload = {
        id: this.id,
        oldName: this.chosenCharacter,
        character: this.character
      };
      this.saveCharacter(payload);
      this.chosenCharacter = this.character.name;
    },
    deleteCharacter() {
      const payload = {
        id: this.id,
        oldName: this.chosenCharacter
      };
      this.removeCharacter(payload);
      this.resetCharacter();
    },
    resetCharacter() {
      this.chosenCharacter = '';
      this.character = {
        name: '',
        race: '',
        level: 1,
        xp: 0,
        hpRolls: [],
        statPoints: 6,
        traitPoints: 2,
        physique: 0,
        finesse: 0,
        mind: 0,
        spirit: 0,
        primaryStats: [],
        tertiaryStats: [],
        dumpStats: [],
        traits: [],
        skills: {
          custom: [],
          values: {},
          skillPoints: {
            physique: 0,
            finesse: 0,
            mind: 0,
            spirit: 0,
            general: 0,
            specialty: 0
          }
        },
        inventory: [],
        equippedArmor: {
          name: 'Unarmored',
          type: 'Unarmored',
          ac: '0',
          price: '0',
          weight: '0'
        },
        equippedMain: {
          name: 'Unarmed',
          type: 'Unarmed',
          size: 'Small',
          damage: '1d4',
          stamina: '4',
          price: '0',
          weight: '0'
        },
        equippedOff: {
          name: 'Unarmed',
          type: 'Unarmed',
          size: 'Small',
          damage: '1d4',
          stamina: '4',
          price: '0',
          weight: '0'
        },
        offHandDisabled: false,
        resetTraits: [],
        resetSkills: {
          custom: [],
          values: {},
          skillPoints: {
            physique: 0,
            finesse: 0,
            mind: 0,
            spirit: 0,
            general: 0,
            specialty: 0
          }
        }
      };
    }
  },
  computed: {
    ...mapState(['id']),
    ...mapState('actsCharacters', ['characters']),
    characterNames() {
      return this.characters.map(character => character.name);
    }
  }
};
</script>

<style></style>
